
export interface GridColumn {
    key: string;
    title: string;
    width: string;
    sortDirection: SortDirection;
    format: DataFormat;
}

export enum DataFormat {
    String = 'string',
    Number = 'number'
}

export enum SortDirection {
    None = '',
    Asc = 'asc',
    Desc = 'desc',
    Disabled = 'disable'
}